import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

import type { UserItem } from '../data-layer/usersTypes';

interface UsersState {
  users: UserItem[];
  totalRecords: number;
  loading: boolean;
  error: string | null;
  filters: {
    includeDetails: boolean;
    userKeys?: number[] | null;
    columnToSort: string;
    globalSearch: string | null;
    max: number;
    offset: number;
    order: string;
  };
}

const initialState: UsersState = {
  users: [],
  totalRecords: 0,
  loading: false,
  error: null,
  filters: {
    includeDetails: false,
    userKeys: [],
    columnToSort: 'userName',
    globalSearch: '',
    max: 25,
    offset: 0,
    order: 'DESC',
  },
};

const usersSlice = createSlice({
  name: 'users',
  initialState,
  reducers: {
    setUsersData: (state, action: PayloadAction<UserItem[]>) => {
      state.users = action.payload;
    },
    setUsersTotalRecords: (state, action: PayloadAction<number>) => {
      state.totalRecords = action.payload;
    },
    setUsersIsLoading: (state, action: PayloadAction<boolean>) => {
      state.loading = action.payload;
    },
    setUsersError: (state, action: PayloadAction<string | null>) => {
      state.error = action.payload;
    },
    updateUsersFilters: (
      state,
      action: PayloadAction<Partial<UsersState['filters']>>
    ) => {
      state.filters = { ...state.filters, ...action.payload };
    },
    resetUsersFilters: (state) => {
      state.filters = initialState.filters;
    },
  },
});

export const {
  setUsersData,
  setUsersTotalRecords,
  setUsersIsLoading,
  setUsersError,
  updateUsersFilters,
  resetUsersFilters,
} = usersSlice.actions;

export default usersSlice.reducer;
